/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import BasePresenter from '@src/js/separate-logic/base-presenter';
import _has from 'lodash/has';
import FillBackground from '../fill-background/index';
import { createGraphicsParser, GraphicsType, isSameParserWhenGraphicsTypeChange } from '@tencent/alloy-graphics';

export default class GraphicContentPresenter extends BasePresenter {
    public init(props: any) {
        this.model.fillBackground.onImgLoaded = this.onImgLoaded;
    }

    // eslint-disable-next-line camelcase
    public componentWillReceiveProps(nextProps) {
        if (isSameParserWhenGraphicsTypeChange(this.model.pathParser.model.type, nextProps.model.bgShape)) {
            this.model.pathParser.update({
                type: nextProps.model.bgShape,
                controlValues: nextProps.model.controlValues,
                width: nextProps.model.width,
                height: nextProps.model.height,
            });
        } else {
            this.model.pathParser = createGraphicsParser({
                type: nextProps.model.bgShape ?? GraphicsType.RECT,
                controlValues: nextProps.model.controlValues,
                width: nextProps.model.width,
                height: nextProps.model.height,
                pathList: nextProps.model.pathList,
            });
        }
    }

    public componentWillUnmount = () => {
        if (this.model.pathParser) {
            this.model.pathParser = null;
        }
        if (this.model.strokeInfo) {
            this.model.strokeInfo = null;
        }
        if (this.model.fillBackground) {
            this.model.fillBackground = null;
        }
    };

    private onImgLoaded = (width, height) => {
        if (_has(this.props.model, 'fillBackground.image.src') && this.model.fillBackground) {
            const { src } = this.props.model.fillBackground.image;
            // console.log("onImgLoaded",width,height,src);
            const { imageSizeMap } = FillBackground;
            if (!imageSizeMap.has(src)) {
                imageSizeMap.set(src, { width, height });
            }
            if (!this.model.fillBackground.checkTileImgShown()) {
                this.setModel({});
            }
        }
    };
}
